// extracted by mini-css-extract-plugin
module.exports = {"staticMap":"StaticMap_staticMap__pMW0E","mapImage":"StaticMap_mapImage__ebs2f","showMapButton":"StaticMap_showMapButton__d5TlR"};